import React, { ForwardedRef } from "react";
import { MenuItemProps } from "@mui/material";
import MuiMenuItem from "@mui/material/MenuItem";

import { useMenuItemStyles } from "./MenuGroup.styles";

function MenuGroup(props: MenuItemProps, ref: ForwardedRef<HTMLLIElement>) {
  const { children, ...other } = props;

  const menuItemClasses = useMenuItemStyles();

  return (
    <MuiMenuItem {...other} disabled ref={ref} classes={menuItemClasses}>
      {children}
    </MuiMenuItem>
  );
}

export default React.forwardRef(MenuGroup);
